<template>
  <div :class="['ui-tag', `ui-tag--${type}`]" :style="getStyles()">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'UiTag',
  props: {
    type: {
      type: String,
      default: 'info'
    },
    bgColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  methods: {
    getStyles () {
      let styles = {}
      if (this.bgColor) {
        styles.backgroundColor = this.bgColor
        styles.borderColor = this.bgColor
      }
      if (this.color) {
        styles.color = this.color
      }
      return styles;
    }
  }
}
</script>

<style lang="scss">
  .ui-tag {
    display: inline-block;
    padding: 5px 11px;
    border-radius: 4px;
    border: 1px solid transparent;
    font-size: 12px;
    white-space: nowrap;

    &--info {
      background-color: #f4f4f5;
      border-color: #f4f4f5;
      color: #909399;
    }

    &--success {
      background: #DFF3DD;
      color: #15BF51;
      border-color: #DFF3DD;
    }

    &--warning {
      color: #E6AB45;
      background: #FEEDC2;
      border-color: #FEEDC2;
    }
    
    &--danger {
      background: #FCDADA;
      color: #FC4849;
      border-color: #FCDADA;
    }
  }
</style>